import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import looppa from 'looppa';
import reduxUtils from 'util/redux';
import ProductTile from 'components/product-tile';
import NoSearchHits from '../search-panel-no-hits';
import VisibilitySensor from 'components/visibility-sensor';
import Loader from 'components/loader';
import { debounce } from 'lodash';
import { PRODUCT_LIST_SEARCH_RESULTS } from 'tracking/constants';
import { SEARCH_SCROLL_DEBOUNCE } from 'constants/debounce-delays';
import SearchPanelHeader from '../search-panel-header';
import { t } from 'translations';
import classnames from 'classnames';

class SearchPanelProductList extends Component {
    static propTypes = {
        isSearching: PropTypes.bool.isRequired,
        isLoadingMore: PropTypes.bool.isRequired,
        loadMore: PropTypes.func.isRequired,
        products: PropTypes.array.isRequired,
        productsTotal: PropTypes.number.isRequired,
    };

    onBottomScroll = () => {
        this.debouncedScroll();
    };

    debouncedScroll = debounce(function() {
        this.props.loadMore();
    }, SEARCH_SCROLL_DEBOUNCE);

    loader = () => {
        return <div className="search-panel-product-list--loader"/>;
    };

    render() {
        const { products, productsTotal, isSearching, isLoadingMore } = this.props;
        return (
            <div>
                <SearchPanelHeader
                    title={`${ t('search.query_result_products_title') } ${ productsTotal > 0
                        ? `(${ productsTotal })`
                        : '' }`}
                />
                <div
                    className={classnames('search-panel-product-list', {
                        'search-panel-product-list__is-searching': isSearching && !isLoadingMore,
                    })}
                >
                    {products.length > 0 ? (
                        <div>
                            <ul className="search-panel-product-list--collection u-reset">
                                {looppa(products)((item, i) => (
                                    <li className="search-panel-product-list--item" key={item.id}>
                                        <ProductTile {...item} position={i} facet="list"
                                            list={PRODUCT_LIST_SEARCH_RESULTS}/>
                                    </li>
                                ))}
                            </ul>
                            <VisibilitySensor onEnter={this.onBottomScroll}>
                                <div className="search-panel-product-list--load-more">
                                    <div className="search-panel-product-list--loader">
                                        {productsTotal > products.length && <Loader/>}
                                    </div>
                                </div>
                            </VisibilitySensor>
                        </div>
                    ) : (
                        <NoSearchHits/>
                    )}

                </div>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isSearching: 'search.isSearching',
        isLoadingMore: 'search.isLoadingMore',
        products: 'search.products',
        productsTotal: 'search.productsTotal',
    }),
    reduxUtils.mapDispatchToProps({
        loadMore: 'search.loadMore',
    }),
)(SearchPanelProductList);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/search/search-panel-product-list/index.js